import React, { useEffect } from 'react';
import { LazyActionableTaskView } from 'app/src/components/ActionableTaskView';
import { Analytics } from '@trello/atlassian-analytics';

export const ActionableTaskInlineDialog: React.FunctionComponent = () => {
  useEffect(() => {
    Analytics.sendScreenEvent({
      name: 'actionableTaskInlineDialog',
    });
  }, []);

  return <LazyActionableTaskView />;
};
